import { useTranslation } from 'react-i18next';
import { LwButton, Toolbox, useFormButtons } from 'redesign';

type ToolboxProps = {
  disabledPrimaryButton?: boolean;
  mutationStatus: 'loading' | 'idle' | 'success' | 'error';
  mode: 'create' | 'update';
  onSubmit: () => void;
  onCancel: () => void;
};

export const ToolboxForm = ({
  onSubmit,
  mutationStatus,
  mode = 'create',
  onCancel,
  disabledPrimaryButton,
}: ToolboxProps) => {
  const { submitButtonProps, cancelButtonProps } = useFormButtons(mutationStatus);
  const { t } = useTranslation('web-common');

  return (
    <Toolbox underline>
      <LwButton
        onClick={onSubmit}
        iconColorMode="stroke"
        {...submitButtonProps}
        disabled={disabledPrimaryButton}
      >
        {mode === 'create' ? t('buttons.create') : t('buttons.save')}
      </LwButton>
      <LwButton iconColorMode="fill" {...cancelButtonProps} onClick={onCancel}>
        {t('buttons.cancel', { ns: 'web-common' })}
      </LwButton>
    </Toolbox>
  );
};
